module.exports = __webpack_public_path__ + "img/palau.dfe3da16.png";